<!-- @format -->

<ng-container *transloco="let t">
  <div class="guidance-div">
    <span class="sis-guidance asterisk-required-guidance" aria-hidden="true">
      <sis-icon [icon]="'required'"></sis-icon>
      {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.REQUIRED_FIELD") }}
    </span>
  </div>
  @if (form) {
    <form [formGroup]="form" autocomplete="on">
      <div class="row buyer-details">
        <div class="col-sm-4">
          <div class="form-group">
            <sis-text-field
              [ngClass]="{ 'cart-error-class': form.controls.firstName.invalid }"
              [control]="form.controls.firstName"
              [id]="'fname'"
              [label]="t('OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.FIRST_NAME')"
              [autocomplete]="'given-name'"
              [attr.tabindex]="-1">
            </sis-text-field>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="form-group">
            <sis-text-field
              [ngClass]="{ 'cart-error-class': form.controls.lastName.invalid }"
              [control]="form.controls.lastName"
              [id]="'lname'"
              [label]="t('OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.LAST_NAME')"
              [autocomplete]="'family-name'"
              [attr.tabindex]="-1">
            </sis-text-field>
          </div>
        </div>
        <div class="col-sm-5">
          <div class="form-group">
            <sis-text-field
              [ngClass]="{ 'cart-error-class': form.controls.email.invalid }"
              [control]="form.controls.email"
              [id]="'email'"
              [label]="t('OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.EMAIL')"
              [autocomplete]="'email'"
              [attr.tabindex]="-1">
            </sis-text-field>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group terms">
            @if (form.controls.acceptTerms.invalid && form.controls.acceptTerms.touched) {
              <div class="accept-terms-error cart-error-class" data-cy="accept-terms-error" [attr.tabindex]="-1">
                <fudis-notification [variant]="'danger'">
                  <fudis-body-text>
                    {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.ACCEPT_TERMS_MISSING_NOTIFICATION") }}
                  </fudis-body-text>
                </fudis-notification>
              </div>
            }
            <sis-form-checkbox [control]="form.controls.acceptTerms" [name]="'terms-of-delivery-checkbox'" data-cy="terms-of-delivery">
              <span class="sis-form-checkbox-label-content">
                {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.ACCEPT_TERMS_PART_1") }}
                <a
                  fudisLink
                  [href]="termsOfDeliveryUrl | localizedString"
                  [external]="true"
                  [title]="t('OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.ACCEPT_TERMS_PART_2_LINK')"></a>
                {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.ACCEPT_TERMS_PART_3") }}
              </span>
            </sis-form-checkbox>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-12">
          <div class="form-group fudis-mb-none">
            @if (paymentType === "STUDY_VOUCHER_PAYMENT") {
              <fudis-notification [variant]="'info'">
                <fudis-body-text>
                  {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.STUDY_VOUCHER_PAYMENT.GUIDANCE_TEXT_1") }}
                </fudis-body-text>
                <fudis-body-text>
                  {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.STUDY_VOUCHER_PAYMENT.GUIDANCE_TEXT_2") }}
                </fudis-body-text>
              </fudis-notification>
            } @else if (paymentType === "MONETARY_PAYMENT") {
              <fudis-notification [variant]="'info'">
                <fudis-body-text>
                  {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.MONETARY_PAYMENT.GUIDANCE_TEXT") }}
                  @if (autoConfirmText) {
                    <span>
                      {{ t("OPEN_UNIVERSITY_CART.WIZARD.CONTACT_INFORMATION.MONETARY_PAYMENT.GUIDANCE_TEXT_AUTO_CONFIRMATION") }}
                    </span>
                  }
                </fudis-body-text>
              </fudis-notification>
            }
          </div>
        </div>
      </div>
    </form>
  }
</ng-container>
